import overviewUrl from '../../../../docs/SHARING-OVERVIEW.pdf?url';

/** docs/SHARING-OVERVIEW.pdf, the one-page picture of roles, copies and keys, built into the app so it opens offline too. */
export function SharingOverviewLink() {
  return (
    <p className="meta">
      <a href={overviewUrl} target="_blank" rel="noopener">
        How sharing works (one-page PDF)
      </a>
    </p>
  );
}
